import React from "react";
// import Principal from "../components/Principal";
import Login from "../pages/Login";
import Footer from "../components/Footer";
//import logo from "../images/distripollo.jpeg";
import alumno from "../images/alumno.jpeg";
import docente from "../images/avatardocente.png";
import remito from "../images/remito.png";
import remitoc from "../images/remitoc.png";
import cuota from "../images/cuota.jpg";
import egreso from "../images/egreso.png";
import rendicion from "../images/rendicion.png";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { Link, useLocation, useHistory } from "react-router-dom";
import "../css/home.css";
import "../css/footer.css";

const Home = () => {
  return (
    <>
    

      {/* comentado desde aqui para hahn</> */}
      <div className="container mt-5">
        <hr />          
        <div className="row text-center mb-3">
          <div className="col-12">
            <h1>Gestion de Datos</h1>
          </div>
        </div>

        <div className="row mb-5 mt-5">
          <div className="row-iconos">
            <div className="col-icono">
              <Link to="/Remitos" className="custom-link">
                <img src={remito} alt="icono viajes" />
                <h3>Remitos</h3>
              </Link>
            </div>
            <div className="col-icono">
              <Link to="/Remitocs" className="custom-link">
                <img src={remitoc} alt="icono viajes" />
                <h3>R. Campo</h3>
              </Link>
            </div>

            <div className="col-icono">
              <Link to="/cajas" className="custom-link">
                <img src={cuota} alt="icono cajas" />
                <h3>Cajas</h3>
              </Link>
            </div>

            <div className="col-icono">
              <Link to="/movimientos" className="custom-link">
                <img src={egreso} alt="icono cajas" />
                <h3>Movimientos</h3>
              </Link>
            </div>

            {/* <div className="col-icono">
              <Link to="/viajes" className="custom-link">
                <img src={rendicion} alt="icono cajas" />
                <h3>Rendiciones</h3>
              </Link>
            </div> */}

          </div>
        </div>
          
      </div>
      <Login />
    </>
  );
};

export default Home;
